module.exports = __webpack_public_path__ + "img/status-team-success.96d528c6.png";